export const TOGGLE_SHOW_PROMO_BAR = 'TOGGLE_SHOW_PROMO_BAR';

export function toggleShowPromoBar(showPromoBar){
    return{
        type: TOGGLE_SHOW_PROMO_BAR,
        mainState: {
            showPromoBar: showPromoBar
        }
    }
}